import getImage from './imageLoader';
import brushImgSrc from '../assets/brushes.png';

var brushImg;
var brushCanvas = document.createElement('canvas');
var brushCtx = brushCanvas.getContext('2d');

// load the brushes PNG
getImage(brushImgSrc).then((img)=>{
  brushImg = img;
});


let lastBrush = null;

const brushes = {

  BRUSHES: [],

  getStampImage(b) {

    if(brushImg && lastBrush!=b) {

      const size = 20;

      // reset canvas
      brushCanvas.width = size;
      brushCanvas.height = size;

      // draw bitmap to canvas so we can use it as a stamp
      brushCtx.drawImage(brushImg, -b.bx, -b.by, size, size, 0, 0, size, size);
    }

    lastBrush = b;

    return brushCanvas;
  }
};

var cols = 6;
var rows = 4;

for (var n = 0; n < cols * rows; n++) {

  var b = {
    idx: n,
    row: Math.floor(n / cols),
    col: Math.round(n % cols)
  };

  b.bx = -10 - b.col * 40;
  b.by = 0 - b.row * 20;

  // pre-compute background position style for feeding vue components
  b.backgroundPosition = b.bx + 'px '+b.by+'px';

  brushes.BRUSHES.push(b);
}

export default brushes;



// WEBPACK FOOTER //
// ./src/util/brushes.js